import { createFileRoute, Navigate } from '@tanstack/react-router';

import Auth from '@/_pages/auth/page';
import { CookieManager } from '@/_shared';

export const Route = createFileRoute('/')({
  component: () => {
    const isLoggedIn = CookieManager.isLoggedIn();
    if (isLoggedIn) {
      return <Auth />;
    }
    return <Navigate to="/login" />;
  },
});
